class TransportStage {
  static SCHEDULED = 'scheduled';

  static IN_TRANSIT = 'inTransit';

  static ARRIVED = 'arrived';
}

export default TransportStage;
